'use client';
import React from 'react';
import GravityForm from 'react-gravity-form';
import styles from './GravityForm.module.scss';

export interface GravityFormContainerProps {
  formId?: number;
  onSubmitSuccess?: () => void;
}

const fetchOptions = {
  headers: {
    Authorization:
      'Basic ' + btoa('ck_6c27b6776eb85c582cdb27558dca48d6e826203d:cs_10e751c0d4cfc2b242bb3cf6782443af4e3cda14'),
    'Content-Type': 'text/plain',
  },
  method: 'GET',
};

export const GravityFormContainer: React.FC<GravityFormContainerProps> = ({ formId, onSubmitSuccess }) => {
  return (
    <div className={styles.gravityForm}>
      <GravityForm
        backendUrl="https://www.benzinga.com/wp-json/gf/v2/forms"
        fetchOptions={fetchOptions}
        formID={formId}
        onSubmitSuccess={onSubmitSuccess}
        populatedFields={{
          page_url: typeof window !== 'undefined' ? window.location.href : '',
        }}
      />
    </div>
  );
};
